import { StyledNewProductForm } from './style';
import { useIntl } from 'react-intl';
import useQueryApiClient from 'utils/useQueryApiClient';
import React, { useState } from 'react';
import { Spinner, Checkbox, Table } from 'ui';
import { Delivery } from 'interfaces/BackendModels';
import { ResponsiveWrapper } from 'admin/components/ResponsiveWrapper';
import MobileList from 'admin/components/MobileLayout/MobileList';

interface DeliveryProps {
  id: number;
  type: 'venipak' | 'omniva' | 'dpd' | 'izipizi' | 'self' | 'delivery';
  price: number;
  selected?: boolean;
  description?: string;
}

interface RequiredProps {
  farmId?: number | null;
  defaultChecked?: boolean;
}

export const NewProductDeliveryForm = ({
  farmId,
  defaultChecked = false,
}: RequiredProps) => {
  const [deliveries, setDeliveries] = useState<DeliveryProps[]>([]);
  const intl = useIntl();

  const { isLoading: deliveriesLoading } = useQueryApiClient({
    request: {
      url: `api/v2/deliveries/farm/${farmId}`,
      disableOnMount: !farmId,
    },
    onSuccess: (response) => {
      setDeliveries(response);
    },
  });

  const columns = [
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => intl.formatMessage({ id: `delivery.${type}` }),
    },
    {
      title: intl.formatMessage({ id: 'general.status' }),
      render: (record: Delivery) => {
        return (
          <Checkbox
            name={['deliveries', record.id.toString(), 'emarket']}
            initialValue={defaultChecked}
          />
        );
      },
    },
  ];

  const mobileItems = {
    bodyFields: [
      {
        name: 'type',
        label: intl.formatMessage({ id: 'general.name' }),
        render: (text: string) =>
          intl.formatMessage({ id: `delivery.${text}` }),
      },
      {
        name: 'deliveries',
        label: intl.formatMessage({ id: 'general.available' }),
        render: (value: undefined, record: DeliveryProps) => {
          return record ? (
            <Checkbox
              name={['deliveries', record.id.toString(), 'emarket']}
              initialValue={defaultChecked}
            />
          ) : null;
        },
      },
    ],
  };

  return (
    <StyledNewProductForm>
      <Spinner spinning={deliveriesLoading}>
        {!deliveriesLoading && !!farmId && deliveries.length === 0 ? (
          <div className="empty-state">
            {intl.formatMessage({ id: 'product.no_active_deliveries' })}
          </div>
        ) : (
          <ResponsiveWrapper
            desktopComponent={
              <Table columns={columns} dataSource={deliveries} />
            }
            mobileComponent={
              <MobileList
                bodyFields={mobileItems.bodyFields}
                dataSource={deliveries}
              />
            }
          />
        )}
      </Spinner>
    </StyledNewProductForm>
  );
};
